import React from "react";
import { areaEntryForPath, areaEntryPermissions } from "../navigation/areaCatalog";
import { toolsItemForPath, toolsItemPermissions, hasToolsItemPermission } from "../../pages/tools/toolsCatalog";
import { settingsPagePermissions } from "../../pages/settings/settingsCatalog";
import { RequireCapability } from "./RequireCapability";
import { RequirePermission } from "./RequirePermission";
import { useAuth } from "./useAuth";

/**
 * Router-Guard aus dem Bereichskatalog: dieselbe Rechtezeile und dieselben Capabilities wie
 * Menüeintrag und Übersichtskarte. Keine eigene Rechteliste in der Route.
 */
export function RequireArea(props: { path: string; children: React.ReactNode }) {
  const entry = areaEntryForPath(props.path);
  const guarded = <RequirePermission anyOf={areaEntryPermissions(entry)}>{props.children}</RequirePermission>;
  return entry.capabilities?.length ? <RequireCapability allOf={entry.capabilities}>{guarded}</RequireCapability> : guarded;
}

/** Werkzeugseiten: Rechtezeile aus `toolsCatalog`, bei Automationen zusätzlich ein Bereich. */
export function RequireTool(props: { path: string; children: React.ReactNode }) {
  const auth = useAuth();
  const item = toolsItemForPath(props.path);
  const allowed = hasToolsItemPermission(item, { hasAnyPermission: auth.hasAnyPermission });
  const guarded = <RequirePermission anyOf={allowed ? toolsItemPermissions(item) : []}>{props.children}</RequirePermission>;
  return item.requiredCapability ? <RequireCapability capabilityKey={item.requiredCapability}>{guarded}</RequireCapability> : guarded;
}

/** Einstellungsseiten: Rechte aus `settingsCatalog` (dieselben wie Kachel und Menügruppe). */
export function RequireSettingsPage(props: { path: string; children: React.ReactNode }) {
  return <RequirePermission anyOf={settingsPagePermissions(props.path)}>{props.children}</RequirePermission>;
}
